import { companyCategoryList } from '../../company/company-category';

export function getIndustryPrompt(companyName: string, companyDescription?: string) {
  const description = companyDescription
    ? `
<COMPANY-DESCRIPTION>
${companyDescription}
</COMPANY-DESCRIPTION>
  `
    : '';

  const categoryListStr = companyCategoryList.join('\n');

  return `
Based on the company information provided below, assign **one** industry category that **best** describes the company's primary activities or services. Choose the most specific and relevant category from the list.

<COMPANY-NAME>
${companyName}
</COMPANY-NAME>

${description}

<CATEGORY-LIST>
${categoryListStr}
</CATEGORY-LIST>
  `;
}

export function getIndustryFunctions() {
  return [
    {
      name: 'getIndustryBasedOnCompanyInformation',
      description: `Assign one industry category that best describes the company based on the provided information.`,
      parameters: {
        type: 'object',
        properties: {
          industryCategory: {
            type: 'string',
            description: 'The assigned industry category from the list.',
          },
        },
        required: ['industryCategory'],
      },
    },
  ];
}
